exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ad-refresh{align-items:center !important;display:flex !important;flex-direction:column;justify-content:center}.ad-refresh-bkgd{background-color:#f7f7f7 !important}", ""]);

